module.exports = __webpack_public_path__ + "img/c70c43d.svg";